import * as ambassadorWixRestaurantsMenusV1Menu from './restaurants-menus-v1-menu-menus.http.js';
import * as ambassadorWixRestaurantsMenusV1MenuTypes from './restaurants-menus-v1-menu-menus.types.js';
import * as ambassadorWixRestaurantsMenusV1MenuUniversalTypes from './restaurants-menus-v1-menu-menus.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createMenu(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.CreateMenuRequest,
  ambassadorWixRestaurantsMenusV1MenuTypes.CreateMenuRequest,
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.CreateMenuResponse,
  ambassadorWixRestaurantsMenusV1MenuTypes.CreateMenuResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Menu.createMenu(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/menus',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateMenus(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.BulkCreateMenusRequest,
  ambassadorWixRestaurantsMenusV1MenuTypes.BulkCreateMenusRequest,
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.BulkCreateMenusResponse,
  ambassadorWixRestaurantsMenusV1MenuTypes.BulkCreateMenusResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Menu.bulkCreateMenus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/menus/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getMenu(): __PublicMethodMetaInfo<
  'GET',
  { menuId: string },
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.GetMenuRequest,
  ambassadorWixRestaurantsMenusV1MenuTypes.GetMenuRequest,
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.GetMenuResponse,
  ambassadorWixRestaurantsMenusV1MenuTypes.GetMenuResponse
> {
  const payload = { menuId: ':menuId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Menu.getMenu(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/menus/{menuId}',
    pathParams: { menuId: 'menuId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listMenus(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.ListMenusRequest,
  ambassadorWixRestaurantsMenusV1MenuTypes.ListMenusRequest,
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.ListMenusResponse,
  ambassadorWixRestaurantsMenusV1MenuTypes.ListMenusResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Menu.listMenus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/menus',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryMenus(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.QueryMenusRequest,
  ambassadorWixRestaurantsMenusV1MenuTypes.QueryMenusRequest,
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.QueryMenusResponse,
  ambassadorWixRestaurantsMenusV1MenuTypes.QueryMenusResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Menu.queryMenus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/menus/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateMenu(): __PublicMethodMetaInfo<
  'PATCH',
  { menuId: string },
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.UpdateMenuRequest,
  ambassadorWixRestaurantsMenusV1MenuTypes.UpdateMenuRequest,
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.UpdateMenuResponse,
  ambassadorWixRestaurantsMenusV1MenuTypes.UpdateMenuResponse
> {
  const payload = { menu: { id: ':menuId' } } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Menu.updateMenu(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/menus/{menu.id}',
    pathParams: { menuId: 'menuId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateMenu(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.BulkUpdateMenuRequest,
  ambassadorWixRestaurantsMenusV1MenuTypes.BulkUpdateMenuRequest,
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.BulkUpdateMenuResponse,
  ambassadorWixRestaurantsMenusV1MenuTypes.BulkUpdateMenuResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Menu.bulkUpdateMenu(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/menus/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateExtendedFields(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.UpdateExtendedFieldsRequest,
  ambassadorWixRestaurantsMenusV1MenuTypes.UpdateExtendedFieldsRequest,
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.UpdateExtendedFieldsResponse,
  ambassadorWixRestaurantsMenusV1MenuTypes.UpdateExtendedFieldsResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Menu.updateExtendedFields(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/menus/{id}/updateExtendedFields',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteMenu(): __PublicMethodMetaInfo<
  'DELETE',
  { menuId: string },
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.DeleteMenuRequest,
  ambassadorWixRestaurantsMenusV1MenuTypes.DeleteMenuRequest,
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.DeleteMenuResponse,
  ambassadorWixRestaurantsMenusV1MenuTypes.DeleteMenuResponse
> {
  const payload = { menuId: ':menuId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Menu.deleteMenu(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/menus/{menuId}',
    pathParams: { menuId: 'menuId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function duplicateMenu(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.DuplicateMenuRequest,
  ambassadorWixRestaurantsMenusV1MenuTypes.DuplicateMenuRequest,
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.DuplicateMenuResponse,
  ambassadorWixRestaurantsMenusV1MenuTypes.DuplicateMenuResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Menu.duplicateMenu(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/menus/{id}/duplicate',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getMenuSiteUrl(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.GetMenuSiteUrlRequest,
  ambassadorWixRestaurantsMenusV1MenuTypes.GetMenuSiteUrlRequest,
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.GetMenuSiteUrlResponse,
  ambassadorWixRestaurantsMenusV1MenuTypes.GetMenuSiteUrlResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Menu.getMenuSiteUrl(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/menus-site-url/menus/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryMenusSiteUrl(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.QueryMenusSiteUrlRequest,
  ambassadorWixRestaurantsMenusV1MenuTypes.QueryMenusSiteUrlRequest,
  ambassadorWixRestaurantsMenusV1MenuUniversalTypes.QueryMenusSiteUrlResponse,
  ambassadorWixRestaurantsMenusV1MenuTypes.QueryMenusSiteUrlResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Menu.queryMenusSiteUrl(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/menus-site-url/menus/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Menu as MenuOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  SeoSchema as SeoSchemaOriginal,
  Keyword as KeywordOriginal,
  Tag as TagOriginal,
  Settings as SettingsOriginal,
  BusinessLocationDetails as BusinessLocationDetailsOriginal,
  ExternalReferenceInfo as ExternalReferenceInfoOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  DeleteOrphanSections as DeleteOrphanSectionsOriginal,
  MenusDataCloningCompleted as MenusDataCloningCompletedOriginal,
  CreateMenuRequest as CreateMenuRequestOriginal,
  CreateMenuResponse as CreateMenuResponseOriginal,
  BulkCreateMenusRequest as BulkCreateMenusRequestOriginal,
  BulkCreateMenusResponse as BulkCreateMenusResponseOriginal,
  BulkCreateMenuResult as BulkCreateMenuResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  GetMenuRequest as GetMenuRequestOriginal,
  GetMenuResponse as GetMenuResponseOriginal,
  ListMenusRequest as ListMenusRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  ListMenusResponse as ListMenusResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  QueryMenusRequest as QueryMenusRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  QueryMenusResponse as QueryMenusResponseOriginal,
  UpdateMenuRequest as UpdateMenuRequestOriginal,
  UpdateMenuResponse as UpdateMenuResponseOriginal,
  BulkUpdateMenuRequest as BulkUpdateMenuRequestOriginal,
  MaskedMenu as MaskedMenuOriginal,
  BulkUpdateMenuResponse as BulkUpdateMenuResponseOriginal,
  BulkMenuResult as BulkMenuResultOriginal,
  UpdateExtendedFieldsRequest as UpdateExtendedFieldsRequestOriginal,
  UpdateExtendedFieldsResponse as UpdateExtendedFieldsResponseOriginal,
  DeleteMenuRequest as DeleteMenuRequestOriginal,
  DeleteMenuResponse as DeleteMenuResponseOriginal,
  RunMenusMultiLocationMigrationRequest as RunMenusMultiLocationMigrationRequestOriginal,
  RunMenusMultiLocationMigrationResponse as RunMenusMultiLocationMigrationResponseOriginal,
  UpdateBusinessLocationIdRequest as UpdateBusinessLocationIdRequestOriginal,
  UpdateBusinessLocationIdResponse as UpdateBusinessLocationIdResponseOriginal,
  CloneMenusRequest as CloneMenusRequestOriginal,
  CloneMenusResponse as CloneMenusResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  SyncContentToMultilingualRequest as SyncContentToMultilingualRequestOriginal,
  SyncContentToMultilingualResponse as SyncContentToMultilingualResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  DuplicateMenuRequest as DuplicateMenuRequestOriginal,
  DuplicateMenuResponse as DuplicateMenuResponseOriginal,
  GetMenuSiteUrlRequest as GetMenuSiteUrlRequestOriginal,
  GetMenuSiteUrlResponse as GetMenuSiteUrlResponseOriginal,
  MenuSiteUrl as MenuSiteUrlOriginal,
  QueryMenusSiteUrlRequest as QueryMenusSiteUrlRequestOriginal,
  QueryMenusSiteUrlResponse as QueryMenusSiteUrlResponseOriginal,
} from './restaurants-menus-v1-menu-menus.types.js';
